var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGroup3181(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fe0103;}.b{fill:none;stroke:#fff;stroke-width:2.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-140 -504)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 28,
    height: 28,
    rx: 5,
    transform: "translate(140 504)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(147 511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-3767.467,754.933h13.382",
    transform: "translate(3767.467 -748.243)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3181);
export default __webpack_public_path__ + "static/media/Group 3181.8e025f81ac6848f1ffd4208aebe0c7e6.svg";
export { ForwardRef as ReactComponent };